export default __webpack_public_path__ + "static/media/rocket_anim_6.017402e1.png";